import axios from 'axios';

export const catalogoApi = axios.create({
  baseURL: process.env.REACT_APP_CATALOGO_API
});

export const slotsApi = axios.create({
  baseURL: process.env.REACT_APP_SLOTS_API
});

export const ViaCepApi = axios.create({
  baseURL: process.env.REACT_APP_VIACEP_API
});

export const BusnessRule = axios.create({
  baseURL: process.env.REACT_APP_BUSINESS_RULE
});

export const ScheduleSpecialistApi = axios.create({
  baseURL: process.env.REACT_APP_SCHEDULE_SPECIALIST_API
});

export const mockServeApi = axios.create({
  baseURL: 'http://localhost:4444'
});

export const specialistsApi = axios.create({
  baseURL: process.env.REACT_APP_SPECIALISTS_PUBLIC_API
});

export const unifiedAppointmentsApi = axios.create({
  baseURL: process.env.REACT_APP_UNIFIED_APPOINTMENTS
});

export const teleorientationApi = axios.create({
  baseURL: process.env.REACT_APP_TELEORIENTATION_BASE_URL
});

export const lambdaValidateApi = axios.create({
  baseURL: process.env.REACT_APP_GET_LAMBDA_VALIDATE_API_URL
});
